// You can use this helper to create a simple CSS version of focal image.
//
// This function converts focal image coordinates which range from -1 to 1
// into CSS `object-position` property values which range from 0% to 100%.
//
// To have an image behave as a focal image you need to:
// 1. Assign CSS property `object-fit: cover`
// 2. Assign result of this function as `object-position` CSS property
export function focalPointToObjectPosition (coordinates) {
  const positionX = Math.round((coordinates.x + 1) * 50)
  const positionY = Math.round((1 - coordinates.y) * 50)
  return `${positionX}% ${positionY}%`
}
